import { render } from "./EmailTemplate.vue?vue&type=template&id=e8d504c6&ts=true"
import script from "./EmailTemplate.vue?vue&type=script&lang=ts"
export * from "./EmailTemplate.vue?vue&type=script&lang=ts"

import "./EmailTemplate.vue?vue&type=style&index=0&id=e8d504c6&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__